import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
//import DialogTitle from "@material-ui/core/DialogTitle";
import ContentCopy from '@material-ui/icons/FileCopy';
import Share from '@material-ui/icons/Share';
import SmsIcon from '@material-ui/icons/Sms';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import axios from 'axios';
import { useNotify,Confirm } from 'react-admin';
import AlertError from '@material-ui/icons/ErrorOutline';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  }
});

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});



const Contact = (props, ...rest) => {
  const [open, setOpen] = useState(false);
  const [openConfirme, setOpenConfirme] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState();

  const classes = useStyles();
  const notify = useNotify();
  //const redirect = useRedirect();

  const {campCode,campId,campType} = props;
  //const title = 'Facture : TLDI Logistique Services';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const smsAuto=(forWho)=>{
    const msg=forWho==='exp' ? 'expéditaires':'desitnataires';
    setConfirmMsg('Etes-vous sûrs de vouloir envoyer automatiquement un SMS à tous les '+msg+' de la campagne '+campCode);
    //handleConfirm();
    setOpenConfirme(true);
    //const resultat = window.confirm('Etes-vous sûrs de vouloir envoyer automatiquement un SMS à tous les '+msg+' de la campagne '+campCode);
  }

  const handleCopyClientsTel=(forWho)=>{
    copyClientsTel(forWho);
    /*
    //let confirmeCopie;
    if(campType==='AERIEN_DE_CNKRY' && forWho==='exp') {
      setConfirmMsgCopy('Attention vous allez copier des numéros Guinéens, si vous envoyez des sms avec votre numéros en France, vous risquez être HORS FORFAIT !');
      //confirmeCopie=window.confirm('Attention vous allez copier des numéros Guinéens, si vous envoyez des sms avec votre numéros en France, vous risquez être HORS FORFAIT !');
      setOpenConfirmeCopy(true);
    }else{
      copyClientsTel(forWho);
    }

    //handleConfirm();
    if(ouiCopy) copyClientsTel(forWho);
    */

  }
  const handleConfirm=()=>{
    setOpenConfirme(false);
  }

  const handleConfirmClose=()=>{
    setOpenConfirme(false);
  }
/*
  const handleConfirmCopy=()=>{
    setOuiCopy(true);
    setOpenConfirmeCopy(false);
  }

  const handleConfirmCloseCopy=(forWho)=>{
    
    setOpenConfirmeCopy(false);
  }
*/


  const copyClientsTel=(forWho)=>{
     // console.log(forWho)
      const config = {
          method: 'GET',
          url:  process.env.REACT_APP_URL +'/camp/getCampagneClientsTel/'+campId+'?typeClient='+forWho,
          headers: {
              "Authorization": "Bearer " + localStorage.getItem('token')
          }
      };

      axios(config).then((response) => {
        //console.log(response.data);
        const msg=forWho==='exp' ? 'expéditaires':'destinataires';
        if(response.data.message!==''){
          copy(response.data.message); 
          notify('Numéros '+msg+' copiés avec succès !', 'success');
        } else {
          copy(' ');
          notify("Cette campagne n'a pas de clients pour le moment ou bien aucun colis n'est chargé dans cette campagne.", 'info');
        }
        
      }).catch(error => {
        //console.log(error)
        // failure side effects go here 
        notify(`${error.message}`, 'warning');
      });
  }

  return (
    <span>
        <Confirm
            isOpen={openConfirme}
            title="Demande confirmation"
            content={confirmMsg}
            onConfirm={handleConfirm}
            onClose={handleConfirmClose}
            confirm="Oui"
            cancel="Non"
        />
     

      <Button onClick={handleClickOpen} color="primary" startIcon={<Share />}>Contact</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {props.titre}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
          <Button
          variant="contained"
          color="primary"
          className={classes.button}
          endIcon={<ContentCopy/>}
          onClick={()=>handleCopyClientsTel('exp')}
      >
        Exp
      </Button>

      <Button
        variant="contained"
        color="default"
        className={classes.button}
        endIcon={<SmsIcon/>}
        onClick={()=>smsAuto('exp')}
      >
        Auto Exp
      </Button>
      
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        endIcon={<ContentCopy/>}
        onClick={()=>handleCopyClientsTel('dest')}
      >
        DST
      </Button>

      <Button
        variant="contained"
        color="default"
        className={classes.button}
        endIcon={<SmsIcon/>}
        onClick={()=>smsAuto('dest')}
      >
        AUTO DST
      </Button>
        </DialogContent>
        <DialogActions >
        <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
        </DialogActions>
      </Dialog>
    </span>
  );

}

export default Contact;
